export default "__VITE_ASSET__23ef0258__"